export interface Article {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  content: string;
  categoryId: string;
  categoryName: string;
  author: string;
  publishDate: string;
  readTime: string;
  views: number;
  tags: string[];
  imageUrl: string;
}

export const articles: Article[] = [
  {
    id: 'art-1',
    title: '17c.com 2026年最新官方入口地址汇总',
    slug: 'latest-official-access-2026',
    excerpt: '本文整理了17c.com在2026年所有可用的官方访问地址和备用入口，帮助您快速找到最稳定的访问方式。',
    content: `<p>随着网络环境的不断变化，17c.com始终保持对用户访问体验的高度重视。以下是2026年最新的官方访问地址汇总：</p>
<h3>主入口地址</h3>
<p>17c.com主域名始终是用户访问的首选：<strong>https://17c.com</strong></p>
<p>该地址采用最新的HTTPS加密协议，确保用户数据传输的安全性。我们建议用户将主入口地址添加至浏览器书签，以便随时访问。</p>
<h3>备用入口</h3>
<p>为了应对各种网络状况，17c.com提供了多个备用访问入口：</p>
<ul>
<li>备用入口一：持续稳定运行，推荐使用</li>
<li>备用入口二：新增节点，速度优化</li>
<li>备用入口三：专线通道，低延迟</li>
</ul>
<h3>如何验证官方地址</h3>
<p>请认准17c.com官方认证标识，所有官方地址均以 <strong>17c.com</strong> 域名结尾。如遇到非官方地址，请立即停止访问并向我们反馈。</p>
<h3>访问建议</h3>
<p>建议用户定期关注本站公告，获取最新的地址更新信息。同时，可以将多个备用入口同时保存，以备不时之需。</p>`,
    categoryId: 'cat-1',
    categoryName: '最新入口',
    author: '17c.com官方',
    publishDate: '2026-08-01',
    readTime: '5分钟',
    views: 15280,
    tags: ['官方地址', '访问入口', '最新地址'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20digital%20network%20access%20portal%20with%20glowing%20connection%20nodes%20on%20a%20clean%20dark%20background%2C%20futuristic%20technology%20concept%2C%20minimalist%20design%2C%20warm%20orange%20and%20teal%20accents%2C%20professional%20atmosphere&width=800&height=450&seq=article-1&orientation=landscape',
  },
  {
    id: 'art-2',
    title: '新用户必看：17c.com完整注册与使用教程',
    slug: 'new-user-registration-tutorial',
    excerpt: '专为新用户准备的详细教程，从注册账号到熟练使用各项功能，手把手教你玩转17c.com。',
    content: `<p>欢迎加入17c.com大家庭！本教程将帮助您快速完成注册并掌握平台的核心功能。</p>
<h3>第一步：访问官方网站</h3>
<p>打开浏览器，在地址栏输入 <strong>https://17c.com</strong> 进入官方网站首页。</p>
<h3>第二步：注册账号</h3>
<p>点击页面右上角的"注册"按钮，填写以下信息：</p>
<ul>
<li>手机号码（用于接收验证码）</li>
<li>设置登录密码（建议包含大小写字母和数字）</li>
<li>验证码确认</li>
</ul>
<h3>第三步：完善个人资料</h3>
<p>注册成功后，建议您完善个人资料，包括昵称、头像等，这将帮助您获得更好的使用体验。</p>
<h3>第四步：探索平台功能</h3>
<p>17c.com提供丰富的功能模块，包括内容浏览、社区交流、个性化设置等。您可以从导航栏开始逐一探索。</p>
<h3>常见问题</h3>
<p>如遇到任何问题，可以访问我们的常见问题页面或联系在线客服获取帮助。</p>`,
    categoryId: 'cat-2',
    categoryName: '使用指南',
    author: '17c.com教程组',
    publishDate: '2026-07-28',
    readTime: '8分钟',
    views: 23450,
    tags: ['注册教程', '新手入门', '使用指南'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20modern%20desk%20setup%20with%20laptop%20showing%20registration%20form%20interface%2C%20warm%20lighting%2C%20welcoming%20atmosphere%2C%20minimalist%20office%20scene%2C%20professional%20tutorial%20concept&width=800&height=450&seq=article-2&orientation=landscape',
  },
  {
    id: 'art-3',
    title: '17c.com安全防护机制全面解析',
    slug: 'security-protection-mechanism',
    excerpt: '深入了解17c.com的多层安全防护体系，包括数据加密、访问验证和隐私保护机制。',
    content: `<p>在网络安全日益重要的今天，17c.com始终将用户安全放在首位。本文将详细介绍平台的多层安全防护机制。</p>
<h3>数据传输加密</h3>
<p>17c.com全站采用HTTPS加密协议，所有用户数据在传输过程中均经过高强度加密，有效防止中间人攻击和数据窃取。</p>
<h3>访问验证机制</h3>
<p>平台采用多重验证确保访问安全：</p>
<ul>
<li>SSL证书认证，验证网站身份真实性</li>
<li>双因素认证（2FA），为账号提供额外保护</li>
<li>异常登录检测，自动识别并阻止可疑访问</li>
</ul>
<h3>隐私保护政策</h3>
<p>17c.com严格遵守隐私保护法规，不会在未经用户授权的情况下收集、使用或分享用户个人信息。</p>
<h3>用户安全建议</h3>
<p>我们建议用户：定期更换密码、不与他人共享账号、使用官方渠道访问、及时更新安全设置。</p>`,
    categoryId: 'cat-3',
    categoryName: '安全须知',
    author: '17c.com安全团队',
    publishDate: '2026-07-25',
    readTime: '6分钟',
    views: 18760,
    tags: ['安全防护', '数据加密', '隐私保护'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20security%20shield%20concept%20with%20glowing%20protection%20layers%2C%20warm%20orange%20and%20teal%20gradient%2C%20minimalist%20cybersecurity%20visual%2C%20clean%20dark%20background&width=800&height=450&seq=article-3&orientation=landscape',
  },
  {
    id: 'art-4',
    title: '访问17c.com时遇到问题？常见问题解答汇总',
    slug: 'access-issues-faq',
    excerpt: '收集了用户访问17c.com时最常遇到的问题及其解决方法，帮助您快速排除故障。',
    content: `<p>以下是我们整理的关于17c.com访问过程中最常见的问题及详细解答。</p>
<h3>Q: 无法打开17c.com怎么办？</h3>
<p>请先检查您的网络连接是否正常。如果网络正常但仍无法访问，可以尝试以下方法：</p>
<ul>
<li>清除浏览器缓存和Cookie后重试</li>
<li>更换浏览器尝试访问</li>
<li>使用我们提供的备用入口地址</li>
<li>检查浏览器是否设置了代理</li>
</ul>
<h3>Q: 页面加载速度慢怎么办？</h3>
<p>页面加载速度受多种因素影响。建议您：检查网络带宽、关闭不必要的后台程序、尝试更换DNS服务器。</p>
<h3>Q: 忘记登录密码如何找回？</h3>
<p>在登录页面点击"忘记密码"，按提示输入注册手机号，系统会发送验证码帮助您重置密码。</p>
<h3>Q: 如何确认访问的是官方网站？</h3>
<p>请确认地址栏显示的域名为 <strong>17c.com</strong>，并检查浏览器地址栏前的安全锁标识。</p>`,
    categoryId: 'cat-4',
    categoryName: '常见问题',
    author: '17c.com客服团队',
    publishDate: '2026-07-20',
    readTime: '7分钟',
    views: 31200,
    tags: ['常见问题', '访问故障', '解决方案'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Friendly%20customer%20support%20concept%20with%20soft%20glowing%20question%20mark%20icons%20floating%2C%20warm%20orange%20and%20teal%20accents%2C%20clean%20minimalist%20design%2C%20helpful%20atmosphere&width=800&height=450&seq=article-4&orientation=landscape',
  },
  {
    id: 'art-5',
    title: '17c.com 2026年第三季度平台功能更新公告',
    slug: '2026-q3-platform-update',
    excerpt: '17c.com在2026年第三季度推出多项全新功能和优化改进，为用户带来更优质的使用体验。',
    content: `<p>感谢广大用户一直以来对17c.com的支持与厚爱。2026年第三季度，我们推出了多项功能更新：</p>
<h3>新增功能</h3>
<ul>
<li><strong>智能导航推荐</strong>：基于用户行为分析，提供个性化的内容推荐</li>
<li><strong>夜间模式</strong>：保护用户视力，提供舒适的夜间浏览体验</li>
<li><strong>一键收藏</strong>：快速收藏感兴趣的页面和内容</li>
</ul>
<h3>性能优化</h3>
<ul>
<li>页面加载速度提升40%</li>
<li>服务器节点扩容，覆盖更多地区</li>
<li>移动端适配全面升级</li>
</ul>
<h3>安全升级</h3>
<p>全面升级安全防护体系，采用最新的加密算法和防护策略，确保用户数据安全。</p>`,
    categoryId: 'cat-5',
    categoryName: '平台动态',
    author: '17c.com产品团队',
    publishDate: '2026-07-15',
    readTime: '4分钟',
    views: 9850,
    tags: ['功能更新', '平台公告', '产品动态'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20digital%20platform%20update%20announcement%20visual%20with%20glowing%20feature%20icons%2C%20warm%20orange%20gradient%2C%20clean%20minimalist%20tech%20concept%2C%20professional%20atmosphere&width=800&height=450&seq=article-5&orientation=landscape',
  },
  {
    id: 'art-6',
    title: '17c.com社区交流指南：如何高效参与讨论',
    slug: 'community-discussion-guide',
    excerpt: '了解17c.com社区的基本规则和交流技巧，帮助您更好地融入社区并获得有价值的信息。',
    content: `<p>17c.com社区是一个开放、友好的交流平台。本指南将帮助您更好地参与社区讨论。</p>
<h3>社区基本规则</h3>
<ul>
<li>尊重他人，保持友善的交流态度</li>
<li>禁止发布违规内容和广告信息</li>
<li>鼓励分享有价值的使用经验和技巧</li>
</ul>
<h3>如何发起讨论</h3>
<p>登录账号后，在社区页面点击"发布新帖"，选择合适的分类标签，撰写清晰明了的标题和内容。</p>
<h3>如何获得帮助</h3>
<p>如果在使用过程中遇到问题，可以在社区中搜索相关话题或直接发帖提问。我们的社区管理员和热心用户都会积极提供帮助。</p>
<h3>社区积分体系</h3>
<p>积极参与社区讨论可以获得积分奖励，积分可用于兑换平台权益和专属标识。</p>`,
    categoryId: 'cat-6',
    categoryName: '社区交流',
    author: '17c.com社区运营',
    publishDate: '2026-07-10',
    readTime: '5分钟',
    views: 12450,
    tags: ['社区指南', '交流技巧', '用户社区'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Diverse%20group%20of%20people%20connecting%20through%20digital%20devices%2C%20warm%20orange%20and%20teal%20community%20visual%2C%20clean%20minimalist%20social%20concept%2C%20friendly%20atmosphere&width=800&height=450&seq=article-6&orientation=landscape',
  },
  {
    id: 'art-7',
    title: '17c.com移动端使用技巧大全',
    slug: 'mobile-usage-tips',
    excerpt: '掌握17c.com在手机和平板设备上的使用技巧，随时随地享受流畅的访问体验。',
    content: `<p>越来越多的用户通过移动设备访问17c.com。本文汇总了移动端的高效使用技巧。</p>
<h3>移动端适配说明</h3>
<p>17c.com已全面适配手机和平板设备，自动识别屏幕尺寸并提供最佳浏览体验。</p>
<h3>快捷操作技巧</h3>
<ul>
<li>下拉刷新页面内容</li>
<li>左滑返回上一页</li>
<li>长按链接可预览内容</li>
<li>双击顶部快速回到页面顶端</li>
</ul>
<h3>省流量模式</h3>
<p>在设置中开启省流量模式，系统将自动优化图片加载策略，减少流量消耗。</p>
<h3>添加到主屏幕</h3>
<p>通过浏览器菜单将17c.com添加到手机主屏幕，像使用App一样快速打开。</p>`,
    categoryId: 'cat-2',
    categoryName: '使用指南',
    author: '17c.com教程组',
    publishDate: '2026-07-05',
    readTime: '4分钟',
    views: 16780,
    tags: ['移动端', '使用技巧', '手机访问'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20clean%20modern%20website%20interface%20on%20minimalist%20desk%20setup%2C%20warm%20orange%20and%20teal%20accents%2C%20professional%20mobile%20browsing%20concept&width=800&height=450&seq=article-7&orientation=landscape',
  },
  {
    id: 'art-8',
    title: '如何辨别17c.com仿冒网站？官方防骗指南',
    slug: 'identify-fake-websites',
    excerpt: '学会识别17c.com的仿冒网站和钓鱼链接，保护您的账号安全和隐私信息。',
    content: `<p>近期我们发现有不法分子仿冒17c.com进行诈骗活动。请仔细阅读本指南，学会辨别真伪。</p>
<h3>官方域名识别</h3>
<p>17c.com的唯一官方域名为 <strong>17c.com</strong>。任何变体域名（如17c.net、17c.cn等）均非官方网站。</p>
<h3>安全标识检查</h3>
<p>访问官方网站时，浏览器地址栏会显示安全锁标识。点击安全锁可以查看网站的SSL证书信息。</p>
<h3>页面特征对比</h3>
<ul>
<li>官方网站页面设计精美，无错别字和排版问题</li>
<li>仿冒网站通常存在大量广告弹窗</li>
<li>官方网站不会通过弹窗索要密码或验证码</li>
</ul>
<h3>举报渠道</h3>
<p>如发现仿冒网站，请立即通过官方客服渠道举报，我们将联合相关部门进行处理。</p>`,
    categoryId: 'cat-3',
    categoryName: '安全须知',
    author: '17c.com安全团队',
    publishDate: '2026-07-01',
    readTime: '5分钟',
    views: 28790,
    tags: ['防骗指南', '仿冒网站', '安全提醒'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Digital%20security%20warning%20concept%20with%20shield%20and%20alert%20symbols%2C%20warm%20orange%20caution%20visual%2C%20clean%20minimalist%20design%2C%20professional%20antifraud%20atmosphere&width=800&height=450&seq=article-8&orientation=landscape',
  },
];

export const getArticleById = (id: string): Article | undefined => {
  return articles.find((a) => a.id === id);
};

export const getArticlesByCategory = (categoryId: string): Article[] => {
  return articles.filter((a) => a.categoryId === categoryId);
};

export const getLatestArticles = (count: number = 4): Article[] => {
  return [...articles]
    .sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime())
    .slice(0, count);
};

export const getPopularArticles = (count: number = 4): Article[] => {
  return [...articles].sort((a, b) => b.views - a.views).slice(0, count);
};